import { render, staticRenderFns } from "./hubOne.vue?vue&type=template&id=44e402b8&scoped=true"
import script from "./hubOne.vue?vue&type=script&lang=js"
export * from "./hubOne.vue?vue&type=script&lang=js"
import style0 from "./hubOne.vue?vue&type=style&index=0&id=44e402b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e402b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e402b8')) {
      api.createRecord('44e402b8', component.options)
    } else {
      api.reload('44e402b8', component.options)
    }
    module.hot.accept("./hubOne.vue?vue&type=template&id=44e402b8&scoped=true", function () {
      api.rerender('44e402b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/lossRateStats/component/hubOne.vue"
export default component.exports